<div class="customers">
    <div class="d-flex">
        <button type="button" class="btn btn-volver mr-auto p-2" (click)="volver()">VOLVER</button>
    </div>
    <div class="card" style="padding: 1rem;">
        <div class="card-body" style="padding: 20px;">
            <div class="row">
                <div class="d-flex justify-content-between">
                    <div>
                        <p style="text-align: left;
                            font: normal normal bold 26px/53px Montserrat;
                            letter-spacing: 0px;
                            color: #00B09E;
                            opacity: 1;">Seguimiento</p>
                    </div>
                    <div class="" style="text-align: left;">
                        <div class="d-flex justify-content-end" style="background: #F6F6F6 0% 0% no-repeat padding-box;
                        border-radius: 10px;
                        opacity: 1;
                        padding: 15px;
                        ">
                            <p class="info-label">JARDÍN INFANTIL: </p>

                            <p class="info-data">{{dataJardin.jardin}}</p>

                            <p class="info-label">CÓDIGO: </p>

                            <p class="info-data">{{dataJardin.rbd}}</p>

                            <p class="info-label">PERIODO: </p>

                            <p class="info-data">{{getPeriodoJardin(dataJardin.tipoJardin)}}</p>

                        </div>
                    </div>
                </div>
            </div>
            <br>
            <br>
            <div #divSpinner class="cargando" [style.display]="cargando ? '' : 'none'">
                <mat-spinner style="margin-top: 15%;margin-left: 35vw;"></mat-spinner>
            </div>
            <div class="row" [style.display]="!cargando ? '' : 'none'">
                <div class="col-sm-12">
                    <ul class="nav nav-tabs">
                        <li class="nav-item" *ngIf="estadoFaseAnual.estadoAnio1">
                            <a class="nav-link" data-bs-toggle="tab" href="#area-year-1">{{faseAnualData.anios[0]?.anio}}</a>
                        </li>
                        <li class="nav-item" *ngIf="estadoFaseAnual.estadoAnio2">
                            <a class="nav-link" [class]="alternativo ? 'active' : ''" data-bs-toggle="tab" href="#area-year-2">{{faseAnualData.anios[1]?.anio}}</a>
                        </li>
                        <li class="nav-item" *ngIf="estadoFaseAnual.estadoAnio3">
                            <a class="nav-link" [class]="alternativo ? '' : 'active'" data-bs-toggle="tab" href="#area-year-3">{{faseAnualData.anios[2]?.anio}}</a>

                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane fade" id="area-year-1" *ngIf="estadoFaseAnual.estadoAnio1">
                            <div class="d-flex flex-row-reverse">
                                <button type="button" class="btn btn-guardar p-2" (click)="guardarFaseAnual(faseAnualData.anios[0])">GUARDAR AVANCES</button>
                            </div>
                            <br>
                            <div *ngFor="let areaData of faseAnualData?.anios[0]?.areas; let indice=index">
                                <app-area-anual-seguimiento [areaData]="areaData" [estadoSeguimientoAnio]='faseAnualData.anios[0].estadoSeguimientoAnio'></app-area-anual-seguimiento>
                            </div>
                        </div>
                        <div class="tab-pane fad " [class]="alternativo ? 'show active' : ''" id="area-year-2" *ngIf="estadoFaseAnual.estadoAnio2">
                            <div class="d-flex flex-row-reverse">
                                <button type="button" class="btn btn-guardar p-2" (click)="guardarFaseAnual(faseAnualData.anios[1])">GUARDAR AVANCES</button>
                            </div>
                            <br>
                            <div *ngFor="let areaData of faseAnualData?.anios[1]?.areas; let indice=index">
                                <app-area-anual-seguimiento [areaData]="areaData" [estadoSeguimientoAnio]='faseAnualData.anios[1].estadoSeguimientoAnio'></app-area-anual-seguimiento>
                            </div>
                        </div>
                        <div class="tab-pane fade" [class]="alternativo ? '' : 'show active'" id="area-year-3" *ngIf="estadoFaseAnual.estadoAnio3">
                            <div class="d-flex flex-row-reverse">
                                <button type="button" class="btn btn-guardar p-2" (click)="guardarFaseAnual(faseAnualData.anios[2])">GUARDAR AVANCES</button>
                            </div>
                            <br>
                            <div *ngFor="let areaData of faseAnualData?.anios[2]?.areas; let indice=index">
                                <app-area-anual-seguimiento [areaData]="areaData" [estadoSeguimientoAnio]='faseAnualData.anios[2].estadoSeguimientoAnio'></app-area-anual-seguimiento>
                            </div>
                        </div>
                    </div>
                    <br>
                </div>
            </div>
        </div>
    </div>
</div>